import type { ReactNode, SyntheticEvent } from "react";

import { BatchDetailLink, ShipmentDetailLink } from "@/components/hub/HubEntityDetailLink";

import type { CartonRow } from "./prepackApi";
import { prepackCartonBatchPeek, prepackCartonShipmentPeek } from "./prepackCartonEntityPeek";

/** Keep entity links from activating a wrapping queue-card click handler. */
export function isolatePrePackQueueCardClick(event: SyntheticEvent): void {
  event.stopPropagation();
}

export function PrePackCartonShipmentLink({
  carton,
  className,
}: {
  carton: CartonRow;
  className?: string;
}): ReactNode {
  return (
    <span onClick={isolatePrePackQueueCardClick}>
      <ShipmentDetailLink
        shipmentId={carton.shipmentId}
        className={className}
        peek={prepackCartonShipmentPeek(carton)}
      />
    </span>
  );
}

export function PrePackCartonBatchLink({
  carton,
  className,
}: {
  carton: CartonRow;
  className?: string;
}): ReactNode {
  return (
    <span onClick={isolatePrePackQueueCardClick}>
      <BatchDetailLink batchId={carton.batchId} className={className} peek={prepackCartonBatchPeek(carton)} />
    </span>
  );
}

export function PrePackCartonShipmentTitle({ carton }: { carton: CartonRow }): ReactNode {
  return (
    <>
      <PrePackCartonShipmentLink carton={carton} />
      {` · Carton ${String(carton.cartonNumber)}`}
    </>
  );
}
